import styled from "styled-components";
import {getColorFromTheme} from "../../utils/style.utils";

export const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, #6420FF 0%, var(--color-primary-dark) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;

    .icon-text-container {
        display: flex;
        align-items: flex-end;
        gap: 1.5rem;
    }

    .app-icon svg {
        width: 50px;
        height: 55px;
    }

    .company-text {
        font-size: 2.5rem;
        font-weight: 700;
        margin: 0;
        color: white;
        letter-spacing: 1px;
    }

    @media (max-width: 768px) {
        .company-text {
            font-size: 2rem;
        }

        .app-icon svg {
            width: 40px;
            height: 44px;
        }
    }
`;